export default __webpack_public_path__ + "static/media/martinFreelancerFeedback.2f85eb32.png";